<main class="container page">
  <div class="row">
    <div class="col-12">
      <h1>Editar Grupo</h1>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="atualizar()" class="content">
    <div class="form-row">
      <mat-form-field appearance="outline" class="field">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="vc_nome" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="field">
        <mat-label>Cliente</mat-label>
        <mat-select formControlName="fk_cliente">
          <mat-option *ngFor="let cliente of clientes" [value]="cliente.sr_id">
            {{ cliente.vc_nome }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="permissions-header">
      <div>
        <h2>Permissões</h2>
        <div class="subtitle">{{ selectedPermissionCount }} selecionadas</div>
      </div>
    </div>

    <ng-container *ngIf="productSections.length; else noPermissions">
      <mat-tab-group
        class="tabs"
        [selectedIndex]="activeSectionIndex"
        (selectedIndexChange)="onSectionIndexChange($event)"
      >
        <mat-tab *ngFor="let section of productSections; trackBy: trackBySectionKey">
          <ng-template mat-tab-label>
            <span class="tab-label">
              {{ section.label }}
              <span class="tab-count">({{ getSelectedCount(section) }}/{{ section.permissoes.length }})</span>
            </span>
          </ng-template>

          <div class="tab-toolbar">
            <mat-form-field appearance="outline" class="search">
              <mat-label>Buscar permissões</mat-label>
              <input matInput [value]="permissionQuery" (input)="permissionQuery = $any($event.target).value" />
              <button
                mat-icon-button
                matSuffix
                type="button"
                aria-label="Limpar busca"
                *ngIf="permissionQuery"
                (click)="clearSearch()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <div class="tab-actions">
              <button
                mat-button
                class="no-hover"
                [disableRipple]="true"
                color="primary"
                type="button"
                (click)="toggleAllInSection(section, true)"
                [disabled]="load"
              >
                Selecionar todas
              </button>
              <button
                mat-button
                class="no-hover"
                [disableRipple]="true"
                color="warn"
                type="button"
                (click)="toggleAllInSection(section, false)"
                [disabled]="load"
              >
                Limpar
              </button>
            </div>
          </div>

          <div class="permissions-list overflow">
            <ng-container *ngIf="getFilteredPermissions(section) as filtered">
              <ng-container *ngIf="filtered.length; else emptyState">
                <div class="permissions-grid">
                  <div
                    class="permission-item"
                    *ngFor="let permissao of filtered; trackBy: trackByPermissaoId"
                  >
                    <mat-checkbox
                      class="perm-checkbox"
                      color="accent"
                      [checked]="isSelected(permissao.sr_id)"
                      (change)="onPermissionToggle(permissao.sr_id, $event.checked)"
                    >
                      <span class="break-word">{{ formatPermissionText(permissao.vc_descricao) }}</span>
                    </mat-checkbox>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <ng-template #emptyState>
              <div class="empty">Nenhuma permissão encontrada.</div>
            </ng-template>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-container>

    <ng-template #noPermissions>
      <div class="empty">Nenhuma permissão disponível para seleção.</div>
    </ng-template>

    <div id="buttons" class="buttons" *ngIf="!load">
      <button class="btn-sucesso" type="submit" [disabled]="!form.valid || selectedPermissionCount === 0">
        Editar
      </button>
      <button (click)="cancel()" class="btn-cancelar" type="button">Cancelar</button>
    </div>
  </form>

  <div class="load" *ngIf="load">
    <mat-progress-spinner diameter="30" class="example-margin" [color]="color" [mode]="mode" [value]="value">
    </mat-progress-spinner>
  </div>
</main>
